import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class AdministartionService {

  userDetails: any = {}
  private complErr = new BehaviorSubject<string>('');
  castCompl = this.complErr.asObservable();

  constructor(private http: HttpClient, private constantsService: ConstantsService) {

  }


  getAddlnLaneList(): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/adminstration/getAdditionalConfig/${this.userDetails.primarySiteId}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));

  }



  updateAddlnLane(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/saveConfiuration/${this.userDetails?.primarySiteId}`, body, { headers: this.constantsService.httpOptions, responseType: 'json' })
      .pipe(
        catchError(this.handleError));
  }


  createAddlnLane(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/createAdditionalConfig/${this.userDetails.primarySiteId}`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }



  deleteAddlnLane(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/deleteAdditionalConfig/${this.userDetails.primarySiteId}`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  getWaitlaneList(): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/adminstration/WL/getWaitLaneConfig/${this.userDetails?.primarySiteId}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }

  createWaitLane(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/WL/createWaitLaneConfig/${this.userDetails.primarySiteId}`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  deleteWaitLane(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/WL/deleteWaitLaneConfig/${this.userDetails.primarySiteId}`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  getCloadMangDetails(): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/adminstration/CLM/getCloadList/${this.userDetails.primarySiteId}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }

  getMasterSetupConfig(): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/adminstration/getMasterSetupConfig/${this.userDetails.primarySiteId}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }
//Adding the new API to insert default configuration for new Site
  updateNewSiteConfigurationProperties(): Observable<any> {
  let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
  this.userDetails = userDetails
  return this.http
    .post(`${this.constantsService.baseAPIURL}/adminstration/saveDefaultSiteConfiuration/${this.userDetails.primarySiteId}`, this.constantsService.httpCustomOptions)
    .pipe(
      catchError(this.handleError));
  }

  updateSiteConfigurationProperties(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/saveSiteConfiuration/${this.userDetails.primarySiteId}`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  deleteCloadMangDetails(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/CLM/deleteCloadList/${this.userDetails.primarySiteId}`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  createCloadMangDetails(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/CLM/saveCloadList/${this.userDetails.primarySiteId}`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  getSiteTypeFromSiteControl(): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/administration/CM/get/siteControl/${this.userDetails.primarySiteId}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }

  loadDataRD(): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/administration/SM/getShopList/${this.userDetails.primarySiteId}/0`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }

  updateShopManagment(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/SM/updateShop`, body, { headers: this.constantsService.httpOptions, responseType: 'json' })
      .pipe(
        catchError(this.handleError));
  }

  addShopManagment(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/SM/addShop`, body, { headers: this.constantsService.httpOptions, responseType: 'json' })
      .pipe(
        catchError(this.handleError));
  }

  deleteShopManagment(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/SM/delete`, body, { headers: this.constantsService.httpOptions, responseType: 'json' })
      .pipe(
        catchError(this.handleError));
  }

  getsystemMang(body: any) {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails

    return this.http
      .get(`${this.constantsService.baseAPIURL}/adminstration/SM/${body}`, { headers: this.constantsService.httpOptions, responseType: 'json' })
      .pipe(
        catchError(this.handleError));
  }

  // getDockDoorType(){
  //   let userDetails=JSON.parse(sessionStorage.getItem('userDetails')!)
  //   this.userDetails = userDetails
  //   return this.http
  //     .get(`${this.constantsService.baseAPIURL}/administration/DD/getDockDoorType/${this.userDetails.primarySiteId}`, this.constantsService.httpCustomOptions)
  //     .pipe(
  //       catchError(this.handleError));
  // }

  // getDockDoorList(){
  //   let userDetails=JSON.parse(sessionStorage.getItem('userDetails')!)
  //   this.userDetails = userDetails
  //   return this.http
  //   .get(`${this.constantsService.baseAPIURL}/administration/DD/getDockDoorList/${this.userDetails.primarySiteId}`, this.constantsService.httpCustomOptions)
  //   .pipe(
  //     catchError(this.handleError));
  // }

  // updateDockManagment(body:any): Observable<any> {
  //   let userDetails=JSON.parse(sessionStorage.getItem('userDetails')!)
  //   this.userDetails = userDetails
  //   return this.http
  //     .post(`${this.constantsService.baseAPIURL}/adminstration/DD/updateDockDoor`,body,{headers : this.constantsService.httpOptions , responseType:'json'})
  //     .pipe(
  //       catchError(this.handleError));
  // }

  editUser(newUser: any) {
    this.complErr.next(newUser);
  }

  getComplainceConfig() {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/adminstration/getComplainceConfig/${this.userDetails.primarySiteId}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }

  updateConfigurationProperties(obj: any) {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/saveConfiuration/${this.userDetails.primarySiteId}`, obj)
      .pipe(
        catchError(this.handleError));
  }

  searchNonComplianceIssues(body: any) {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    let body1 = {exportIndicator : body.exportIndicator}
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/CR/searchNonComplianceIssues/${body.fromDate}/${body.todate}/${body.siteID}`,body1, {
        headers: this.constantsService.httpOptions, responseType: 'text'
      })
      .pipe(
        catchError(this.handleError));
  }



  updateNonComplianceIssues(bodyValue: any) {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    let body = []
    body.push({
      "id": bodyValue.rowID,
      "issueId": bodyValue.issueID
    })
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/CR/updateNonComplianceIssues/${bodyValue.siteID}`, body, { headers: this.constantsService.httpOptions, responseType: 'json' })
      .pipe(
        catchError(this.handleError));
  }

  deleteNonComplianceIssues(bodyValue: any) {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    let body = {
      "nonComplianceIssueIds": bodyValue.rowID
    }

    console.log("body", body)

    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/CR/deleteNonComplianceIssues/${bodyValue.siteID}`, body, { headers: this.constantsService.httpOptions, responseType: 'json' })
      .pipe(
        catchError(this.handleError));
  }

  getRouteSetupConfigList(): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/adminstration/getRouteSetupConfig/${this.userDetails.primarySiteId}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));

  }

  createPutawayConfig(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/createPutawayConfig/${this.userDetails.primarySiteId}`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  updatePutawayConfig(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/updatePutawayConfig/${this.userDetails.primarySiteId}`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  deletePutawayConfig(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/deletePutawayConfig/${this.userDetails.primarySiteId}`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  getDockManagement(): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/administration/DM/getDockList/${this.userDetails.primarySiteId}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));

  }

  public addDock(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/DM/addDock`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public updateDock(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/DM/updateDock`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public deleteDock(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/DM/delete`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  // public getWorkdayManagement(body: any): Observable<any> {
  //   let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
  //   this.userDetails = userDetails
  //   return this.http
  //     .get(`${this.constantsService.baseAPIURL}/adminstration/WM/getCalendarWorkDayJoin/${body.siteid}/${body.fdate}/${body.tdate}`, this.constantsService.httpCustomOptions)
  //     .pipe(
  //       catchError(this.handleError));
  // }

  public getWorkdayManagement(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    let body1:any = {"exportIndicator":body.exportIndicator}
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/WM/getCalendarWorkDayJoin/${body.siteid}/${body.fdate}/${body.tdate}`, body1, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public addWorkday(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/WM/insertCalendarWorkDayJoin`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public updateWorkday(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/WM/updateCalendarWorkDayJoin`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public deleteWorkDay(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/WM/deleteCalendarWorkDayJoin`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public getShopData(body: any): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/adminstration/WM/getShopData/${body.siteId}/${body.shopId}`, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public getPartsPCBConfig(): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/administration/getPartsPCBConfig/${this.userDetails.primarySiteId}`, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public updatePartsPCBconfig(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/administration/updatePartsPCBconfig`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public getReturnsPCBConfig(): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .get(`${this.constantsService.baseAPIURL}/administration/getReturnsPCBConfig/${this.userDetails.primarySiteId}`, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public updateReturnsPCBConfig(body: any): Observable<any> {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetails
    return this.http
      .post(`${this.constantsService.baseAPIURL}/administration/updateReturnsPCBConfig`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public uploadExcelFile(upload: any): Observable<any> {
    let userDetail = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetail
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/workday/upload/${this.userDetails.id}/${this.userDetails.primarySiteId}`, upload, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  public uploadWorkdayManagementExcelFile(upload: any): Observable<any> {
    let userDetail = JSON.parse(sessionStorage.getItem('userDetails')!)
    this.userDetails = userDetail
    return this.http
      .post(`${this.constantsService.baseAPIURL}/adminstration/workdayManagement/upload/${this.userDetails.id}/${this.userDetails.primarySiteId}`, upload, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse) {
    return throwError(error.message || "Server Error");
  }


}
